// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-side-drawer[data-v-24c63638]{z-index:5555!important;background-color:#dcdcdc!important}.modal-wrapper[data-v-24c63638]{z-index:7777!important;max-width:50vw}.summary-wrapper[data-v-24c63638]{background-color:#fff!important;padding:50px}", ""]);
// Exports
module.exports = exports;
